import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
  DownOutlined,
} from "@ant-design/icons";
import { Table, Tooltip, Input, Radio } from "antd";
import { isEvalReviewed } from "./evalAccountability";
import shoe from "../../../assets/img/Shoes.svg";
import book from "../../../assets/img/open-book.svg";
import clock from "../../../assets/img/clock-outline.svg";
import { Checkbox, Switch } from "antd";
import React, { useEffect, useState, useReducer } from "react";
import undoCircleImg from "../../../assets/img/schedule/undo-circle.svg";
import IndividualizedFeedbackIcon, {
  individualizedFeedbackCount,
} from "./IndividualizedFeedbackIcon";
import running from "../../../assets/img/running.svg";
import doublePeople from "../../../assets/img/double-people.png";
import eye from "../../../assets/img/eye-alt.svg";
import consumable from "../../../assets/img/consumable.svg";
import check from "../../../assets/img/check.png";
import handBrake from "../../../assets/img/hand-brake.svg";
import maskSquare from "../../../assets/img/mask-square.png";
import { Dropdown, Space } from "antd";
import { Button, Modal } from "antd";
import stats from "../../../assets/img/add-hexagon.svg";
import positiveImpact from "../../../assets/img/positiveImpact.svg";
import positiveImpactAction from "../../../assets/img/Action.svg";
import ModalModules from "./modals";
import ExpandableModules from "./expandable";
import football from "../../../assets/img/football-ball.svg";
import CustomSwitchButtons, {
  TackleRadioButtons,
  FlagSwitchButtons,
  EffortsSwitchButtons,
  CarryRadioButtons,
} from "./CustomSwitchButtons";
import { allowedPosition } from "./positions";

const CheckboxGroup = Checkbox.Group;

export const evalStatusColumn = (width = "9%") => ({
  title: "Eval Status",
  dataIndex: "seen",
  align: "center",
  width,
  key: "eval_status",
  render: (_text, item) => {
    if (item.disabled) {
      return <span className="text-[#A9B6C2]">—</span>;
    }
    const reviewed = isEvalReviewed(item);
    return (
      <Tooltip
        title={
          reviewed
            ? "Player reviewed their individual evaluation"
            : "Player has not viewed their individual evaluation"
        }
      >
        <div
          className={`flex items-center justify-center gap-1 text-[12px] ${
            reviewed ? "text-[#00B21E]" : "text-[#A40E17]"
          }`}
        >
          {reviewed ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
          <span>{reviewed ? "Reviewed" : "Not Viewed"}</span>
        </div>
      </Tooltip>
    );
  },
});

// Add table styles
const tableStyles = `
/* Apply only to your evaluation table, not AntD’s internal tables */
.eva-table .ant-table table {
  table-layout: fixed !important;
  visibility: visible !important;
}

.eva-table .ant-table-thead > tr > th {
  position: sticky;
  top: 0;
  z-index: 2;
  background: #fff; /* Keep header readable */
}

.eva-table .ant-table-body {
  overflow-y: auto !important;
  max-height: 600px; /* or adjust for your popup size */
}

`;

const DisciplineRadioButtons = ({
  defaultState,
  handleQuickUpdate,
  title,
  item,
  img,
  tooltipTitle,
  tooltipTitleThree,
  tooltipTitleTwo,
  tooltipTitleFour,
  imageTwo,
  imageThree,
  imageFour,
  value,
}) => {
  let parts = [];
  const options = [
    {
      label: (
        <Tooltip title={tooltipTitle}>
          <img src={img} />
        </Tooltip>
      ),
      value: 1,
    },
    {
      label: (
        <Tooltip title={tooltipTitleTwo}>
          <img src={imageTwo} />
        </Tooltip>
      ),
      value: 2,
    },
    {
      label: (
        <Tooltip title={tooltipTitleThree}>
          <img src={imageThree} />
        </Tooltip>
      ),
      value: 4,
    },
    {
      label: (
        <Tooltip title={tooltipTitleFour}>
          <img src={imageFour} />
        </Tooltip>
      ),
      value: 8,
    },
  ];

  const [checkedValues, setCheckedValues] = useState(false);
  const onChange = (checkedValues) => {
    setCheckedValues(checkedValues);
    let value = 0;
    if (checkedValues.length) {
      value = checkedValues?.reduce((a, b) => a + b);
    }
    handleQuickUpdate(item.id, item.athlete, title, value);
  };

  const handleButtonClick = (value) => {
    handleQuickUpdate(item.id, item.athlete, title, value);
  };
  useEffect(() => {
    processDefault();
  }, [defaultState]);

  const processDefault = () => {
    let _sum = defaultState;

    _sum = _valueBreakDown(_sum, 8);
    _sum = _valueBreakDown(_sum, 4);
    _sum = _valueBreakDown(_sum, 2);
    _sum = _valueBreakDown(_sum, 1);
    setCheckedValues(parts);
  };

  const _valueBreakDown = (_sum, part) => {
    if (_sum >= part) {
      parts.push(part);
      _sum = _sum - part;
    }
    return _sum;
  };

  return (
    <div className="discipline disciplinesradiodiv actor flex w-[100%] items-center justify-center ">
      <div className="button-group flex w-[100%] items-center justify-center ">
        <CheckboxGroup
          options={options}
          value={checkedValues}
          onChange={onChange}
        />
      </div>
    </div>
  );
};

const PuntDistance = ({
  item,
  handleQuickUpdate,
  setDistanceModal,
  distanceModal,
  defaultState,
}) => {
  const [distance, setDistance] = useState(defaultState);
  const [inside, setInside] = useState(item.punt_inside_20);
  const [fair, setFair] = useState(item.punt_fair_catch);
  const updateGrade = (path, value) => {
    handleQuickUpdate(item.id, item.athlete, path, value);
  };
  return (
    <>
      <Modal
        open={distanceModal}
        width={634}
        footer={null}
        closable={false}
        onCancel={() => {
          setDistanceModal(false);
        }}
        title={
          <div className="flex font-inter text-[14px] text-[#0F1A24] items-center">
            <span className=" font-bold">{distanceModal?.title}</span>
            <div className="w-[1px] h-[30px] bg-[#A9B6C2] mx-2"></div>
            <span className="font-[400]">
              {item?.first_name} {item?.last_name}
            </span>
          </div>
        }
      >
        <div className="flex flex-col w-full mt-4">
          <div
            style={{ border: "1px solid #F3F5F7)" }}
            className="w-full flex flex-col text-sm font-bold text-[#20364B]"
          >
            <div className="w-full flex">
              <div
                style={{ border: "1px solid #F3F5F7)" }}
                className="w-[25%] flex items-center p-3 justify-center bg-[#F3F5F7]"
              >
                <span>{distanceModal?.title}</span>
              </div>
              <div
                style={{ border: "1px solid #F3F5F7)" }}
                className="w-[20%] flex items-center p-3 justify-center turn-over actor"
              >
                <Input
                  defaultValue={distanceModal.default}
                  onChange={({ target: { value } }) => setDistance(value)}
                  className="w-[70%]"
                  size="large"
                />
              </div>
              {distanceModal?.hasOptions ? (
                <>
                  {" "}
                  <div
                    style={{ border: "1px solid #F3F5F7)" }}
                    className="w-[25%] flex items-center p-3 justify-center"
                  >
                    <Checkbox
                      defaultChecked={item.punt_inside_20}
                      onChange={({ target: { checked: e } }) =>
                        setInside(e ? 1 : 0)
                      }
                    >
                      <span className="text-[#2E4D6B]">Inside 20</span>
                    </Checkbox>
                  </div>
                  <div
                    style={{ border: "1px solid #F3F5F7)" }}
                    className="w-[25%] flex items-center p-3 justify-center"
                  >
                    <Checkbox
                      defaultChecked={item.punt_fair_catch}
                      onChange={({ target: { checked: e } }) =>
                        setFair(e ? 1 : 0)
                      }
                    >
                      <span className="text-[#2E4D6B]">Fair Catch</span>
                    </Checkbox>
                  </div>{" "}
                </>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="flex items-center justify-between text-md mt-4  w-full flex-col">
            <button
              onClick={() => {
                handleQuickUpdate(
                  item.id,
                  item.athlete,
                  distanceModal.path,
                  distance,
                );
                distanceModal?.hasOptions &&
                  handleQuickUpdate(
                    item.id,
                    item.athlete,
                    "punt_inside_20",
                    inside,
                  );
                distanceModal?.hasOptions &&
                  handleQuickUpdate(
                    item.id,
                    item.athlete,
                    "punt_fair_catch",
                    fair,
                  );
                setDistanceModal(false);
              }}
              className="flex items-center focus:outline-0 self-end justify-center w-[30%] bg-[#1A91FF] text-[#ffffff] h-11 rounded-[4px]"
            >
              <span className="ml-2">Save</span>
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export const defaultModalReducerStates = {
  defensive: false,
  turnover: false,
  offensive: false,
  qbcarry: false,
  qbreception: false,
  qbcompletion: false,
  throw: false,
  target: false,
  kicker: false,
  special_teams: false,
  return: false,
  ol: false,
  punt: false,
  feedback_modal: false,
  field_goal_distance: false,
  missed_field_goal_distance: false,
};

export function modalReducer(state, action) {
  const action_list = {
    "defensive-modal": {
      ...defaultModalReducerStates,
      defensive: true,
    },
    "turnover-modal": {
      ...defaultModalReducerStates,
      turnover: true,
    },
    "qbcarry-modal": {
      ...defaultModalReducerStates,
      qbcarry: true,
    },
    "punt-modal": { ...defaultModalReducerStates, punt: true },
    "qbreception-modal": {
      ...defaultModalReducerStates,
      qbreception: true,
    },
    "qbcompletion-modal": {
      ...defaultModalReducerStates,
      qbcompletion: true,
    },
    "throw-modal": { ...defaultModalReducerStates, throw: true },
    "target-modal": { ...defaultModalReducerStates, target: true },
    "kicker-modal": { ...defaultModalReducerStates, kicker: true },
    "special-teams-modal": {
      ...defaultModalReducerStates,
      special_teams: true,
    },
    "return-modal": { ...defaultModalReducerStates, return: true },
    "ol-modal": { ...defaultModalReducerStates, ol: true },
    feedback_modal: { ...defaultModalReducerStates, feedback_modal: true },
    field_goal_distance: {
      ...defaultModalReducerStates,
      field_goal_distance: true,
    },
    missed_field_goal_distance: {
      ...defaultModalReducerStates,
      missed_field_goal_distance: true,
    },
    "close-modal": defaultModalReducerStates,
  };
  const new_state = action_list[action.type];
  return new_state;
}

const Columns = (props) => {
  const [distanceModal, setDistanceModal] = useState(false);
  const [expandedRowKey, setExpandedRowKey] = useState(null);
  const [currentModalType, setCurrentModalType] = useState(null);
  const [storeItem, setStoreItem] = useState({});
  const [modalState, dispatchModalState] = useReducer(
    modalReducer,
    defaultModalReducerStates,
  );
  const [lastOpenedById, setLastOpenedById] = useState({});
  const [counts, setCounts] = useState({});
  const [oPositionTitle, setOPositionTitle] = useState("");
  const popoutWidth = (defaultWidth, popoutOnlyWidth) =>
    props.isPopout ? popoutOnlyWidth : defaultWidth;

  const handleExpandToggle = (record, modalType) => {
    if (record.disabled) return;
    const isExpanded = expandedRowKey === record.id;
    const isSameModal = currentModalType === modalType;
    const skipDispatchModal = [
      "field_goal_distance",
      "missed_field_goal_distance",
    ];
    if (isExpanded && isSameModal) {
      setExpandedRowKey(null);
      dispatchModalState({ type: "close-modal" });
      setCurrentModalType(null);
    } else {
      setExpandedRowKey(record.id);
      setCurrentModalType(modalType);
      if (!skipDispatchModal.includes(modalType)) {
        dispatchModalState({ type: modalType });
      }
      setStoreItem(record);
    }
  };

  const handleUpdateCount = (id) => {
    setCounts((prev) => ({
      ...prev,
      [id]: {
        count: (prev[id]?.count || 0) + 1,
        countSelf: 1,
      },
    }));
  };

  const sendFeedback = (detail, id) => {
    props.handleQuickUpdate(
      props.feebackItem?.id,
      props.feebackItem?.athlete,
      "positive_feedback",
      detail,
    );
    handleToggleFeedback(null);
  };

  useEffect(() => {
    if (!props.playerList || props.playerList.length === 0) return;

    const newCounts = {};
    props.playerList.forEach((player) => {
      newCounts[player.id] = {
        count: individualizedFeedbackCount(player, !!props.groupFeedback),
        countSelf: 0,
      };
    });

    setCounts(newCounts);
  }, [props.playerList, props.groupFeedback]);

  const onFeedbackItem = (item) => {
    handleToggleFeedback(item);
    props.setFeebackItem(item);
    handleExpandToggle(item, "feedback_modal");
    console.log("calling thissssss", item.disabled);
  };

  const PositiveFeedback = ({
    text,
    item,
    athlete,
    count,
    countSelf,
    handleUpdateCount,
    setCount,
    sendFeedback,
  }) => {
    return (
      <div
        className={
          feedback_type == "analytical" ? "table-action flex" : "flex"
        }
      >
        <IndividualizedFeedbackIcon
          count={count + countSelf}
          flash={props.feedbackFlashId != null && props.feedbackFlashId == item.id}
          onClick={async () => {
            if (
              feedback_type !== "analytical" &&
              feedback_type !== "grading"
            ) {
              if (item?.disabled) {
                await props.handleCreateGrades(
                  athlete,
                  allowedPosition[props.data.code],
                  props.data?.id,
                  (details) => {
                    onFeedbackItem(details);
                  },
                );
              }
              handleToggleFeedback(item);
              props.setFeebackItem(item);
              handleExpandToggle(item, "feedback_modal");
            } else {
              if (item.disabled) {
                return;
              }
              handleToggleFeedback(item);
              props.setFeebackItem(item);
              handleExpandToggle(item, "feedback_modal");
            }
          }}
        />
      </div>
    );
  };
  const columns = {};
  const findRowData = (table_id, part) => {
    const item =
      props.playerListGrades?.find(({ athlete }) => athlete == table_id) || {};
    return item[part];
  };
  const preDefaults = [
    {
      title: () => {
        return (
          <div
            className={
              props?.isPopout
                ? "p-1 flex items-center justify-center"
                : "p-2 flex items-center justify-center"
            }
          >
            {!props?.isPopout ? (
              <Dropdown menu={{ items }} disabled={props.isPopout}>
                <a
                  onClick={(e) => e.preventDefault()}
                  className="border-[1px] border-solid border-black gap-[2px] p-1 flex items-center justify-center rounded-md"
                >
                  <DownOutlined size={10} />
                  <img src={doublePeople} className="w-[15px]" />
                </a>
              </Dropdown>
            ) : (
              <Dropdown menu={{ items }} disabled={props.isPopout}>
                <a
                  onClick={(e) => e.preventDefault()}
                  className="border-[1px] border-solid border-black gap-[2px] p-1 flex items-center justify-center rounded-md"
                >
                  <DownOutlined size={6} />
                  <img src={doublePeople} className="w-[10px]" />
                </a>
              </Dropdown>
            )}
          </div>
        );
      },

      dataIndex: "id",
      align: "center",
      key: "id",
      width: "5%",
      render: (text, item) => {
        if (item.disabled)
          return (
            <>
              <Checkbox
                checked={false}
                onChange={() =>
                  props.handleCreateGrades(
                    text,
                    allowedPosition[props.data.code],
                    props.data?.id,
                  )
                }
              ></Checkbox>
            </>
          );
        return (
          <>
            <Checkbox
              checked={true}
              onChange={() => props.handleRemoveGrades(item.id)}
            ></Checkbox>
          </>
        );
      },
    },
    {
      title: "Player Name",
      dataIndex: "id",
      align: "left",
      width: "10%",
      key: "player_name",
      render: (text, item) => {
        return (
          <div
            className={props.isPopout ? "p-2 text-start " : "py-2 text-start "}
          >
            {/* <Avatar
                        size={24}
        style={{
            fontSize: '12px',
             
          backgroundColor: '#fde3cf', color: '#f56a00'
        }}  
      >
      <p style={{
            position: 'relative',
    bottom: '2px'
      }}>{item.id[0].toUpperCase()}</p> 
      </Avatar> {' '} */}
            {item.first_name} {item.last_name}
          </div>
        );
      },
    },
    // {
    //   title: 'Position',
    //   dataIndex: 'positions',
    //   align: 'center',
    //   key: 'positions'
    // },

    {
      title: "Execution",
      dataIndex: "assignment_executed",
      align: "center",
      width: "7%",
      key: "assignment_executed",
      render: (text, item) => (
        <EffortsSwitchButtons
          item={item}
          defaultState={text}
          handleQuickUpdate={props.handleQuickUpdate}
          title="assignment_executed"
        />
      ),
    },
    {
      title: "Effort",
      dataIndex: "great_effort",
      align: "center",
      width: "7%",
      key: "great_effort",
      render: (text, item) => (
        <EffortsSwitchButtons
          item={item}
          defaultState={text}
          handleQuickUpdate={props.handleQuickUpdate}
          title="great_effort"
        />
      ),
    },
    evalStatusColumn(),
  ].filter(Boolean);

  const postDefaults = [
    {
      title: "Positive Impact",
      dataIndex: "positive_impact",
      width: "6%",
      align: "center",
      key: "turn_over_created",
      render: (text, item) => {
        return (
          <div
            onClick={() => {
              if (item.disabled) return;
              props.handleQuickUpdate(
                item.id,
                item.athlete,
                "positive_impact",
                !text ? 1 : 0,
              );
            }}
            className="flex w-[100%] items-center justify-center"
          >
            {text == 1 && (
              <img
                src={positiveImpactAction}
                className="w-[60%] max-w-[35px] cursor-pointer"
              />
            )}
            {(text === 0 || !text) && (
              <img
                src={positiveImpact}
                className="w-[60%] max-w-[35px] cursor-pointer"
              />
            )}
          </div>
        );
      },
    },
    {
      title: "Individualized Feedback",
      dataIndex: "positive_feedback",
      width: "8%",
      align: "center",
      key: "positive_feedback",
      render: (text, item) => {
        const rowCount = counts[item.id]?.count || 0;
        const rowCountSelf = counts[item.id]?.countSelf || 0;

        return (
          <PositiveFeedback
            text={text}
            item={item}
            athlete={item.id}
            count={rowCount}
            countSelf={rowCountSelf}
            handleUpdateCount={() => handleUpdateCount(item.id)}
            sendFeedback={(detail) => sendFeedback(detail, item.id)}
          />
        );
      },
    },
    {
      title: "Reset",
      dataIndex: "id",
      width: "6%",
      align: "center",
      className: "p-0",
      key: "action",
      render: (text, item) => {
        return (
          <div className="table-action mx-auto">
            <Tooltip title="Reset Eval">
              <Button
                onClick={() => {
                  if (item.disabled === true) return;
                  props.handleTrashGrades(
                    item.id,
                    item.athlete,
                    allowedPosition[props.data.code],
                    props.data?.id,
                  );
                }}
                icon={
                  <img
                    src={undoCircleImg}
                    className="min-w-[25px] w-[50%]  max-w-[35px]"
                  />
                }
              />
            </Tooltip>
          </div>
        );
      },
    },
  ];

  columns.defensiveLine = [
    ...preDefaults,

    {
      title: "Stat",
      dataIndex: "turnovers",
      width: "6%",
      align: "center",
      key: "turn_over_created",
      render: (text, item) => {
        return (
          <div
            className={`flex w-[100%] items-center justify-center ${
              item.disabled === true ? "cursor-not-allowed" : "cursor-pointer"
            }`}
          >
            <img
              onClick={() => handleExpandToggle(item, "defensive-modal")}
              src={stats}
              className="w-[50%] min-w-[20px] max-w-[30px]"
            />
          </div>
        );
      },
    },
    ...postDefaults.slice(1),
  ];

  columns.quarterback = [
    ...preDefaults,
    {
      title: "Discipline",
      dataIndex: "missed_pat",
      align: "center",
      width: "12%",
      key: "discipline",
      render: (text, item) => (
        <DisciplineRadioButtons
          item={item}
          defaultState={text}
          handleQuickUpdate={props.handleQuickUpdate}
          title="missed_pat"
          img={shoe}
          imageTwo={eye}
          imageThree={book}
          imageFour={clock}
          tooltipTitle="Footwork"
          tooltipTitleTwo="Eyes"
          tooltipTitleThree="Read"
          tooltipTitleFour="Timing"
        />
      ),
    },

    {
      title: "Throw",
      dataIndex: "positive_impact",
      width: "8%",
      align: "center",
      key: "turn_over_created",
      render: (text, item) => {
        return (
          <div className="flex w-[100%] items-center justify-center">
            <div
              className={`flex w-[30px] items-center justify-center rounded-full h-[30px] xl:w-[2.5vw] xl:h-[2.5vw] ${
                item.disabled === true ? "cursor-not-allowed" : "cursor-pointer"
              } ${
                item.receptions ||
                item.td ||
                item.yards_after_catch ||
                item.interception
                  ? "bg-[#BCECB5]"
                  : "bg-[#EAEDF0]"
              }`}
              onClick={() => handleExpandToggle(item, "throw-modal")}
            >
              <img
                src={football}
                className="w-[80%] cursor-pointer max-w-[35px]"
              />
            </div>
          </div>
        );
      },
    },
    {
      title: "Stat",
      dataIndex: "positive_impact",
      width: "8%",
      align: "center",
      key: "turn_over_created",
      render: (text, item) => {
        return (
          <div className="flex w-[100%] items-center justify-center">
            <div
              className={`flex w-[30px] items-center justify-center rounded-full h-[30px] xl:w-[2.5vw] xl:h-[2.5vw] ${
                item.disabled === true ? "cursor-not-allowed" : "cursor-pointer"
              }  ${
                item.completions ||
                item.td ||
                item.yards_after_catch ||
                item.yards_after_contact ||
                item.missed_tackles ||
                item.caused_fumble ||
                item.total_carries ||
                item.fumble_lost
                  ? "bg-[#BCECB5]"
                  : "bg-[#EAEDF0]"
              }  `}
              onClick={() => {
                handleExpandToggle(item, "target-modal");
                setOPositionTitle("qb");
              }}
            >
              <img
                src={stats}
                className="w-[70%] cursor-pointer max-w-[35px]"
              />
            </div>
          </div>
        );
      },
    },
    ...postDefaults.slice(1),
  ];
  columns.offensive = [
    ...preDefaults,
    {
      title: "Flag",
      dataIndex: "penalties",
      width: "7%",
      align: "center",
      key: "flagged",
      render: (text, item) => (
        <FlagSwitchButtons
          item={item}
          defaultState={text}
          handleQuickUpdate={props.handleQuickUpdate}
          title="penalties"
        />
      ),
    },
    {
      title: "Carry",
      dataIndex: "total_carries",
      width: "8%",
      align: "center",
      key: "carry",
      render: (text, item) => (
        <CustomSwitchButtons
          item={item}
          defaultState={text}
          handleQuickUpdate={props.handleQuickUpdate}
          title="total_carries"
        />
      ),
    },
    {
      title: "Reception",
      dataIndex: "receptions",
      width: "8%",
      align: "center",
      key: "reception",
      render: (text, item) => (
        <CarryRadioButtons
          item={item}
          defaultState={text}
          handleQuickUpdate={(a, b, c, d, e, f) => {
            handleExpandToggle(item, "qbreception-modal");
            setStoreItem(item);
            props.handleQuickUpdate(a, b, c, d, e, f);
          }}
          title="receptions"
          img={handBrake}
          tooltipTitle="Drop"
        />
      ),
    },
    {
      title: "Pancake",
      dataIndex: "pancakes",
      width: "8%",
      align: "center",
      key: "pancakes",
      render: (text, item) => (
        <CustomSwitchButtons
          item={item}
          defaultState={text}
          handleQuickUpdate={props.handleQuickUpdate}
          title="pancakes"
        />
      ),
    },
    ...postDefaults,
  ];
  const [showPassPro, setShowPassPro] = useState(true);
  const [modal, contextHolder] = Modal.useModal();

  columns.offensiveLinePass = [
    ...preDefaults,
    {
      title: "Flag",
      dataIndex: "penalties",
      align: "center",
      width: "7%",
      key: "flagged",
      render: (text, item) => (
        <FlagSwitchButtons
          item={item}
          defaultState={text}
          handleQuickUpdate={props.handleQuickUpdate}
          title="penalties"
        />
      ),
    },
    {
      title: "Big Hit",
      dataIndex: "catchable_balls",
      width: "8%",
      align: "center",
      key: "big_hits",
      render: (text, item) => {
        return (
          <CustomSwitchButtons
            item={item}
            defaultState={text}
            handleQuickUpdate={props.handleQuickUpdate}
            title="catchable_balls"
          />
        );
      },
    },
    {
      title: "Knockdown",
      dataIndex: "knockdowns",
      align: "center",
      key: "knockdowns",
      render: (text, item) => {
        return (
          <CustomSwitchButtons
            item={item}
            defaultState={text}
            handleQuickUpdate={props.handleQuickUpdate}
            title="knockdowns"
          />
        );
      },
    },
    {
      title: "Pancake",
      dataIndex: "pancakes",
      width: "8%",
      align: "center",
      key: "pancakes",
      render: (text, item) => (
        <CustomSwitchButtons
          item={item}
          defaultState={text}
          handleQuickUpdate={props.handleQuickUpdate}
          title="pancakes"
        />
      ),
    },
    {
      title: "Pass Protection",
      dataIndex: "pass_pro_sacks",
      align: "center",
      width: "8%",
      key: "pass_pro",
      render: (text, item) => {
        if (!showPassPro)
          return (
            <div className="actor flex w-[100%] items-center justify-center ">
              ----
            </div>
          );

        return (
          <TackleRadioButtons
            item={item}
            defaultState={text || 1}
            handleQuickUpdate={(a, b, c, d, e, f) => {
              if (d == 2) {
                setShowPassPro(false);
                const ids = [];
                props.playerList.map((grade) => {
                  if (
                    Object.keys(grade).includes("assignment_executed") &&
                    grade.pass_pro_sacks != 2
                  ) {
                    ids.push({ id: grade?.id, athlete: grade.athlete });
                  }
                });
                props.handleMultipleQuickUpdate(ids, c, d, e, f);
              } else {
                props.handleQuickUpdate(a, b, c, d, e, f);
              }
            }}
            title="pass_pro_sacks"
            imageTwo={consumable}
            imageThree={check}
            tooltipTitle="Lost"
            tooltipTitleTwo="RPO"
            text={text}
            tooltipTitleThree="Won"
            color="grey"
            colorThree="onefive-active"
          />
        );
      },
    },

    {
      title: "Stat",
      dataIndex: "turnovers",
      width: "6%",
      align: "center",
      key: "turn_over_created",
      render: (text, item) => {
        return (
          <div
            className={`flex w-[100%] items-center justify-center ${
              item.disabled === true ? "cursor-not-allowed" : "cursor-pointer"
            }`}
          >
            <img
              onClick={() => {
                handleExpandToggle(item, "ol-modal");
              }}
              src={stats}
              className="w-[50%] min-w-[20px] max-w-[35px]"
            />
          </div>
        );
      },
    },
    ...postDefaults,
  ];
  columns.offensiveLine = [
    ...preDefaults,

    {
      title: "Stat",
      dataIndex: "turnovers",
      width: "6%",
      align: "center",
      key: "turn_over_created",
      render: (text, item) => {
        return (
          <div
            className={`flex w-[100%] items-center justify-center ${
              item.disabled === true ? "cursor-not-allowed" : "cursor-pointer"
            }`}
          >
            <img
              onClick={() => {
                handleExpandToggle(item, "ol-modal");
              }}
              src={stats}
              className="w-[50%] min-w-[20px] max-w-[35px]"
            />
          </div>
        );
      },
    },
    ...postDefaults.slice(1),
  ];

  columns.offenseRB = [
    ...preDefaults,
    {
      title: "Stat",
      dataIndex: "positive_impact",
      width: "8%",
      align: "center",
      key: "turn_over_created",
      render: (text, item) => {
        return (
          <div className="flex w-[100%] items-center justify-center">
            <div
              className={`flex w-[30px] items-center justify-center rounded-full h-[30px] xl:w-[2.5vw] xl:h-[2.5vw]   cursor-pointer ${
                item.disabled === true ? "cursor-not-allowed" : "cursor-pointer"
              } ${
                item.completions ||
                item.td ||
                item.yards_after_catch ||
                item.yards_after_contact ||
                item.missed_tackles ||
                item.caused_fumble ||
                item.total_carries
                  ? "bg-[#BCECB5]"
                  : "bg-[#EAEDF0]"
              }  `}
              onClick={() => {
                handleExpandToggle(item, "target-modal");
                setOPositionTitle("rb");
              }}
            >
              <img src={stats} className="w-[70%] max-w-[35px]" />
            </div>
          </div>
        );
      },
    },

    ...postDefaults.slice(1),
  ];

  columns.offense = [
    ...preDefaults,
    {
      title: "Stat",
      dataIndex: "positive_impact",
      width: "8%",
      align: "center",
      key: "turn_over_created",
      render: (text, item) => {
        return (
          <div className="flex w-[100%] items-center justify-center">
            <div
              className={`flex w-[30px] items-center justify-center rounded-full h-[30px] xl:w-[2.5vw] xl:h-[2.5vw]   cursor-pointer ${
                item.disabled === true ? "cursor-not-allowed" : "cursor-pointer"
              } ${
                item.completions ||
                item.td ||
                item.yards_after_catch ||
                item.yards_after_contact ||
                item.missed_tackles ||
                item.caused_fumble ||
                item.total_carries
                  ? "bg-[#BCECB5]"
                  : "bg-[#EAEDF0]"
              }  `}
              onClick={() => {
                handleExpandToggle(item, "target-modal");
              }}
            >
              <img src={stats} className="w-[70%] max-w-[35px]" />
            </div>
          </div>
        );
      },
    },

    ...postDefaults.slice(1),
  ];

  columns.kicker = [
    ...preDefaults,
    // {
    //   title: "Distance",
    //   dataIndex: "punt_distance",
    //   align: "center",
    //   key: "punt_distance",
    //   render: (text, item) => (
    //     <PuntDistance
    //       item={item}
    //       distanceModal={distanceModal}
    //       handleQuickUpdate={props.handleQuickUpdate}
    //       setDistanceModal={setDistanceModal}
    //       defaultState={text}
    //     />
    //   ),
    // },
    {
      title: "Stat",
      dataIndex: "td",
      align: "center",
      width: "6%",
      key: "td",
      render: (text, item) => {
        return (
          <div
            className={`flex w-[100%] items-center justify-center ${
              item.disabled === true ? "cursor-not-allowed" : "cursor-pointer"
            }`}
          >
            <img
              onClick={() => {
                handleExpandToggle(item, "kicker-modal");
              }}
              src={stats}
              className="w-[50%] min-w-[20px] max-w-[35px]"
            />
          </div>
        );
      },
    },
    ...postDefaults.slice(1),
  ];
  columns.specialTeams = [
    ...preDefaults,
    // {
    //   title: "Tackle",
    //   dataIndex: "tackles",
    //   width: "10%",
    //   align: "center",
    //   key: "tackle",
    //   render: (text, item) => (
    //     <TackleRadioButtons
    //       item={item}
    //       defaultState={text}
    //       handleQuickUpdate={props.handleQuickUpdate}
    //       title="tackles"
    //       tooltipTitle="Missed Tackle"
    //       textTwo="AST"
    //       tooltipTitleTwo="Assisted Tackle"
    //       textThree={1}
    //     />
    //   ),
    // },
    // {
    //   title: "Unselfish Block",
    //   dataIndex: "catchable_balls",
    //   width: "8%",
    //   align: "center",
    //   key: "catchable_balls",
    //   render: (text, item) => (
    //     <CustomSwitchButtons
    //       item={item}
    //       defaultState={text}
    //       handleQuickUpdate={props.handleQuickUpdate}
    //       title="catchable_balls"
    //     />
    //   ),
    // },
    // {
    //   title: "Return",
    //   dataIndex: "td",
    //   align: "center",
    //   width: "8%",
    //   key: "td",
    //   render: (text, item) => {
    //     return (
    //       <div
    //         className={`flex w-[100%] items-center justify-center ${
    //           item.disabled === true ? "cursor-not-allowed" : "cursor-pointer"
    //         }`}
    //       >
    //         <img
    //           onClick={() => handleExpandToggle(item, "return-modal")}
    //           src={stats}
    //           className="w-[40%] max-w-[35px]"
    //         />
    //       </div>
    //     );
    //   },
    // },
    {
      title: "Stat",
      dataIndex: "td",
      align: "center",
      width: "8%",
      key: "td",
      render: (text, item) => {
        return (
          <div
            className={`flex w-[100%] items-center justify-center ${
              item.disabled === true ? "cursor-not-allowed" : "cursor-pointer"
            }`}
          >
            <img
              onClick={() => handleExpandToggle(item, "return-modal")}
              src={stats}
              className="w-[40%] max-w-[35px]"
            />
          </div>
        );
      },
    },

    ...postDefaults.slice(1),
  ];

  columns.feedbackOnly = [
    {
      title: "Player Name",
      dataIndex: "id",
      align: "center",
      width: "13%",
      key: "player_name",
      render: (text, item) => {
        return (
          <div className="">
            {item.first_name} {item.last_name}
          </div>
        );
      },
    },
    {
      title: "Position",
      dataIndex: "position",
      align: "center",
      key: "position",
      width: "12%",
      render: (text, item) => {
        return <div className="">{props.data.code}</div>;
      },
    },

    {
      title: "Individualized Feedback",
      dataIndex: "positive_feedback",
      width: "35%",
      align: "left",
      key: "positive_feedback",
      render: (text, item) => {
        const rowCount = counts[item.id]?.count || 0;
        const rowCountSelf = counts[item.id]?.countSelf || 0;
        return (
          <PositiveFeedback
            text={text}
            item={item}
            athlete={item.id}
            count={rowCount}
            countSelf={rowCountSelf}
            handleUpdateCount={() => handleUpdateCount(item.id)}
            sendFeedback={(detail) => sendFeedback(detail, item.id)}
          />
        );
      },
    },
    {
      title: ".",
      dataIndex: "positive_feedbacks",
      width: "40%",
      align: "left",
      key: "positive_feedbacks",
      render: (text, item) => (
        <div>
          {/* <input
            value={text}
            onFocus={() => {
              setFeebackItem(item);
            }}
            onChange={(e) => {
              const updatedValue = e.target.value;
              item.positive_feedbacks = updatedValue;
              setIndividualFeedback(updatedValue);
            }}
            placeholder="type individual feedback here"
            className="w-full p-1 focus:outline-none"
            // onMouseLeave={() => {
            //   // handleUpdateCount();
            //   props.handleQuickUpdate(
            //     feebackItem?.id,
            //     feebackItem?.athlete,
            //     "positive_feedback",
            //     individualFeedback
            //   );
            //   handleToggleFeedback(null);
            // }}
          /> */}
        </div>
      ),
    },
  ];
  columns.grading = [
    {
      title: () => {
        if (props.isPopout) return <div className="w-[40px]"></div>;
        return (
          <Dropdown menu={{ items }} disabled={props.isPopout}>
            <a
              onClick={(e) => e.preventDefault()}
              className="border-[1px] border-solid border-black gap-[2px] p-1 flex items-center justify-center rounded-md"
            >
              <DownOutlined size={10} />
              <img src={doublePeople} className="w-[15px]" />
            </a>
          </Dropdown>
        );
      },
      dataIndex: "id",
      align: "center",
      key: "id",
      width: popoutWidth("4.8%", "40px"),
      render: (text, item) => {
        if (item.disabled)
          return (
            <>
              <Checkbox
                checked={false}
                onChange={() =>
                  props.handleCreateGrades(
                    text,
                    allowedPosition[props.data.code],
                    props.data?.id,
                  )
                }
              ></Checkbox>
            </>
          );
        return (
          <>
            <Checkbox
              checked={true}
              onChange={() => props.handleRemoveGrades(item.id)}
            ></Checkbox>
          </>
        );
      },
    },
    {
      title: "Player Name",
      dataIndex: "id",
      align: "center",
      width: popoutWidth("13%", "120px"),
      key: "player_name",
      render: (text, item) => {
        return (
          <div className="">
            {item.first_name} {item.last_name}
          </div>
        );
      },
    },
    {
      title: "Execution",
      dataIndex: "assignment_executed",
      align: "center",
      width: popoutWidth("8%", "80px"),
      key: "assignment_executed",
      render: (text, item) => (
        <EffortsSwitchButtons
          item={item}
          defaultState={text}
          handleQuickUpdate={props.handleQuickUpdate}
          title="assignment_executed"
        />
      ),
    },
    {
      title: "Effort",
      dataIndex: "great_effort",
      align: "center",
      width: popoutWidth("8%", "80px"),
      key: "great_effort",
      render: (text, item) => (
        <EffortsSwitchButtons
          item={item}
          defaultState={text}
          handleQuickUpdate={props.handleQuickUpdate}
          title="great_effort"
        />
      ),
    },
    evalStatusColumn(popoutWidth("10%", "100px")),
    {
      title: "Individualized Feedback",
      dataIndex: "positive_feedback",
      width: popoutWidth("35%", "120px"),
      align: "left",
      key: "positive_feedback",
      render: (text, item) => {
        const rowCount = counts[item.id]?.count || 0;
        const rowCountSelf = counts[item.id]?.countSelf || 0;

        return (
          <PositiveFeedback
            text={text}
            item={item}
            athlete={item.id}
            count={rowCount}
            countSelf={rowCountSelf}
            handleUpdateCount={() => handleUpdateCount(item.id)}
            sendFeedback={(detail) => sendFeedback(detail, item.id)}
          />
        );
      },
    },
    {
      title: "Reset",
      dataIndex: "id",
      width: popoutWidth("10%", "50px"),
      align: "center",
      className: "p-0",
      key: "action",
      render: (text, item) => {
        return (
          <div className="table-action mx-auto">
            <Tooltip title="Reset Eval">
              <Button
                onClick={() => {
                  if (item.disabled === true) return;
                  props.handleTrashGrades(
                    item.id,
                    item.athlete,
                    allowedPosition[props.data.code],
                    props.data?.id,
                  );
                }}
                icon={
                  <img
                    src={undoCircleImg}
                    className="min-w-[25px] w-[50%]  max-w-[35px]"
                  />
                }
              />
            </Tooltip>
          </div>
        );
      },
    },
  ];

  const handleToggleFeedback = (item) => {
    props.setFeeback(!props.feeback);
    props.setFeebackItem(item);
  };
  const _cols = {
    DB: columns.defensiveLine,
    DL: columns.defensiveLine,
    LB: columns.defensiveLine,
    S: columns.defensiveLine,
    C: columns.defensiveLine,
    DB: columns.defensiveLine,
    DF: columns.defensiveLine,
    IB: columns.defensiveLine,
    OB: columns.defensiveLine,
    QB: columns.quarterback,
    TE: columns.offense,
    WR: columns.offense,
    RB: columns.offenseRB,
    OS: columns.offense,
    OL: columns.offensiveLine,
    OLP: columns.offensiveLinePass,

    K: columns.kicker,
    ST: columns.specialTeams,
    feedback: columns.feedbackOnly,
    grading: columns.grading,
  };

  useEffect(() => {
    setShowPassPro(true);
  }, [props.formPlay]);

  const confirm = (n) => {
    modal.confirm({
      title: "Confirm",
      icon: <ExclamationCircleOutlined />,
      content: `This action will pre-select the Top ${n} players on your depth chart for the remainder of this game`,
      okText: "Yes",
      cancelText: "No",
      onOk() {
        addMultipleGrades(n);
      },
      onCancel() {
        // console.log('Cancel');
      },
    });
  };

  const addMultipleGrades = (n) => {
    const dataSource = props.playerList
      .sort((a, b) => a.rank - b.rank)
      .slice(0, n);

    const ids = dataSource
      .filter((i) => !Object.keys(i).includes("assignment_executed"))
      .map((i) => i.id);

    props.handleCreateMultipleGrades(
      ids,
      allowedPosition[props.data?.code],
      props.data?.id,
      props.data?.odk,
    );
  };

  const paramsss = new URLSearchParams(window.location.search);
  let feedback_type = paramsss.get("t");

  const items = [
    {
      key: "1",
      label: <a onClick={() => confirm(1)}>Always select top 1 players</a>,
    },
    {
      key: "2",
      label: <a onClick={() => confirm(2)}>Always select top 2 players</a>,
    },
    {
      key: "3",
      label: <a onClick={() => confirm(3)}>Always select top 3 players</a>,
    },
    {
      key: "4",
      label: <a onClick={() => confirm(4)}>Always select top 4 players</a>,
    },
    {
      key: "5",
      label: <a onClick={() => confirm(5)}>Always select top 5 players</a>,
    },

    {
      key: "6",
      label: <a onClick={() => confirm(6)}>Always select top 6 players</a>,
    },
    {
      key: "8",
      label: <a onClick={() => confirm(8)}>Always select top 8 players</a>,
    },
    {
      key: "10",
      label: <a onClick={() => confirm(10)}>Always select top 10 players</a>,
    },
  ];

  return (
    <div className="eva-table-body">
      {contextHolder}
      <style>{tableStyles}</style>

      <ModalModules
        state={modalState}
        school_id={props.school_id}
        loadAllPlayerList={props.loadAllPlayerList}
        item={storeItem}
        play={props.formPlay}
        getStats={props.getStats}
        handleUpdatePlay={props.handleUpdatePlay}
        update={props.handleQuickUpdate}
        dispatch={dispatchModalState}
        close={() =>
          dispatchModalState({
            type: "close-modal",
          })
        }
      />
      <Table
        bordered
        scroll={{ y: 600 }}
        rowKey="id"
        loading={props.playerListLoading}
        columns={
          feedback_type === "analytical"
            ? _cols[props.data.code] || []
            : feedback_type === "grading"
              ? _cols["grading"]
              : _cols["feedback"]
        }
        expandable={{
          expandedRowRender: (record) => (
            <ExpandableModules
              state={modalState}
              school_id={props.school_id}
              loadAllPlayerList={props.loadAllPlayerList}
              item={record}
              play={props.formPlay}
              getStats={props.getStats}
              handleUpdatePlay={props.handleUpdatePlay}
              update={props.handleQuickUpdate}
              dispatch={dispatchModalState}
              distanceModal={distanceModal}
              handleUpdateCount={handleUpdateCount}
              positive_feedback={props?.feebackItem?.positive_feedback}
              groupFeedback={props?.groupFeedback}
              sendFeedback={sendFeedback}
              handleExpandToggle={handleExpandToggle}
              handleQuickUpdate={props?.handleQuickUpdate}
              close={() =>
                dispatchModalState({
                  type: "close-modal",
                })
              }
              setStoreItem={setStoreItem}
              storeItem={storeItem}
              setDistanceModal={setDistanceModal}
              lastOpenedById={lastOpenedById}
              setLastOpenedById={setLastOpenedById}
              showPassPro={showPassPro}
              setShowPassPro={setShowPassPro}
              handleMultipleQuickUpdate={props?.handleMultipleQuickUpdate}
              playerList={props.playerList}
              oPositionTitle={oPositionTitle}
            />
          ),
          expandedRowKeys: expandedRowKey ? [expandedRowKey] : [],
          onExpand: () => {},
          expandIcon: () => null,
          expandIconColumnIndex: -1,
          onExpandedRowsChange: (keys) => setExpandedRowKey(keys),
        }}
        dataSource={props.playerList.sort((a, b) => a.rank - b.rank)}
        size="middle"
        pagination={false}
        rowClassName={(record, index) => {
          if (feedback_type === "analytical" && record.disabled) {
            return "row-disabled";
          } else if (feedback_type === "grading" && record.disabled) {
            return "row-disabled";
          }
          return "";
        }}
      />
    </div>
  );
};

export default Columns;
